@let inUnifiedListingMode = featureFlagService.featureFlags()[featureFlagEnum.UNIFIED_LISTING];
<div class="mainHeaderArea">
    <div class="pageInfo">
        @if (inUnifiedListingMode && isOnListingsOrOutletDetailsPage()) {
            @if (showFeatureGroupSearchBasedOnUrl()) {
                <app-feature-group-search class="header-version" />
            }
        } @else {
            <div class="breadcrumbs">
                @for (breadcrumb of breadcrumbs; track breadcrumb; let last = $last) {
                    @if (!!breadcrumb.onClick) {
                        <a (click)="breadcrumb.onClick()" (keydown.enter)="breadcrumb.onClick()" tabindex="0" class="linkLike">
                            @if (breadcrumb.icon) {
                                <i class="icon far" [ngClass]="'fa-' + breadcrumb.icon"></i>
                            }
                            {{ breadcrumb.shouldNotTranslateLabel ? breadcrumb.label : (breadcrumb.label | translate) }}
                        </a>
                    } @else if (breadcrumb.url) {
                        <a [routerLink]="[breadcrumb.url]">
                            @if (breadcrumb.icon) {
                                <i class="icon far" [ngClass]="'fa-' + breadcrumb.icon"></i>
                            }
                            {{ breadcrumb.shouldNotTranslateLabel ? breadcrumb.label : (breadcrumb.label | translate) }}
                        </a>
                    } @else {
                        <span>
                            @if (breadcrumb.icon) {
                                <i class="icon far" [ngClass]="'fa-' + breadcrumb.icon"></i>
                            }
                            {{ breadcrumb.shouldNotTranslateLabel ? breadcrumb.label : (breadcrumb.label | translate) }}
                        </span>
                    }

                    @if (!last) {
                        <span><i class="icon fas fa-chevron-right"></i></span>
                    }
                }
            </div>
        }
    </div>

    <div class="sideButtons">
        @if (userMenuVisible) {
            <app-menu #userMenu class="userMenu" [positioning]="['bottom', 'left']">
                <button class="user button small transparent" menuActivator>
                    <div class="name-icon">
                        {{
                            (userApiService.currentUser?.firstName?.charAt(0) ?? '') +
                                (userApiService.currentUser?.lastName?.charAt(0) ?? '')
                        }}
                    </div>
                    <span #menuActivatorReference>{{
                        (userApiService.currentUser?.firstName ?? '') + '&nbsp;' + (userApiService.currentUser?.lastName ?? '')
                    }}</span>
                    <i class="icon fa-regular fa-fw fa-chevron-down"></i>
                </button>

                <ul class="menuList">
                    <li class="menuItem" (click)="navigateToMyUserProfile()">
                        <a>
                            {{ 'header.userMenu.profile' | translate }}
                        </a>
                    </li>
                    <li class="menuItem" (click)="logout()">
                        <a>
                            {{ 'header.userMenu.logout' | translate }}
                        </a>
                    </li>
                </ul>
            </app-menu>
        }

        @if (notificationsMenuVisible) {
            <app-menu class="notificationsMenu" #notificationsMenu [positioning]="['bottom', 'left']">
                <button class="button small transparent onlyIcon" menuActivator (click)="getUnreadNotifications()">
                    <span class="iconStack">
                        <i class="icon far fa-fw fa-bell"></i>
                        @if (newNotificationCount()) {
                            <span class="counterBadge">{{ newNotificationCount() }}</span>
                        }
                    </span>
                </button>

                <ul class="menuList">
                    @for (notification of latestNotifications(); track notification) {
                        <li class="menuItem disableHover complexMenuItem">
                            <div>
                                <div>
                                    {{ notification.operationName }}
                                </div>
                                <div class="subMenuItem">
                                    @if (notification.completedDateTime) {
                                        <div>
                                            {{ notification.completedDateTime | date: 'MMMM d, yyyy HH:mm' }}
                                        </div>
                                    }
                                </div>
                            </div>
                            <div class="buttonMenuItem">
                                @if (notification.downloadLink) {
                                    <div>
                                        <i class="fas fa-fw fa-download" (click)="downloadFile(notification.downloadLink)"></i>
                                    </div>
                                } @else if (notification.buttonConfig) {
                                    <div>
                                        <i
                                            [class]="['fa', 'fa-fw', 'fa-' + notification.buttonConfig.icon]"
                                            [title]="notification.buttonConfig.tooltip | translate"
                                            (click)="handleGenericButtonAction(notification.buttonConfig)"
                                        >
                                        </i>
                                    </div>
                                }
                            </div>
                        </li>
                    }
                    @if (latestNotifications() && latestNotifications().length > 0) {
                        <li class="menuItem active centeredMenuItem" (click)="navigateToNotifications()">
                            <span>{{ 'header.userNotificationsTable.seeAll' | translate }}</span>
                        </li>
                    }
                </ul>
            </app-menu>
        }

        <app-menu class="languageMenu" #languageAppMenu [positioning]="['bottom', 'left']">
            <button class="button small transparent onlyIcon" menuActivator>
                <i class="icon fas fa-fw fa-language"></i>
            </button>

            <ul class="menuList">
                @for (language of supportedLanguages; track language.languageCode) {
                    <li
                        class="menuItem"
                        (click)="changeLanguage(language)"
                        [ngClass]="{ active: language.languageCode === currentLanguage() }"
                    >
                        <img [src]="IMAGES.TRANSPARENT_GIF" class="flag" [ngClass]="'flag-' + language.flag" alt="flag" />
                        {{ language.label }}
                    </li>
                }
            </ul>
        </app-menu>
    </div>
</div>
